<template>
  <!-- :style="{ strokeDashoffset: strokeDashoffset }" -->
  <svg
    class=""
    :viewBox="`0 0 ${radius * 2} ${radius * 2}`"
    :width="radius * 2"
    :height="radius * 2"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <mask id="mask01">
        <circle
          id="c1"
          :r="normalizedRadius"
          :cx="radius"
          :cy="radius"
          fill="none"
          stroke="white"
          :stroke-width="stroke"
          :stroke-dasharray="segmentsMask"
          pathLength="1000"
        />
      </mask>
    </defs>
    <g :transform="`rotate(-90 ${radius} ${radius})`">
      <circle
        class="stroke-white"
        fill="transparent"
        :cx="radius"
        :cy="radius"
        :r="normalizedRadius"
        :stroke-width="stroke"
        pathLength="1000"
        mask="url(#mask01)"
      />
      <circle
        class="stroke-emerald-600"
        fill="transparent"
        :cx="radius"
        :cy="radius"
        :r="normalizedRadius"
        :stroke-dasharray="segmentedProgress"
        :stroke-width="stroke"
        pathLength="1000"
        mask="url(#mask01)"
      />
    </g>
  </svg>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  radius: number
  progress: number
  stroke: number
  segments?: number
}

const props = defineProps<Props>()

const normalizedSegments = computed(() => (props.segments || 10))
const segmentsMask = computed(() => `${(1000 - normalizedSegments.value * 5) / normalizedSegments.value} 5`)
const segmentedProgress = computed(() => `${(((props.progress || 0) / normalizedSegments.value) | 0) * normalizedSegments.value * (normalizedSegments.value)} 1000`)

const normalizedRadius = computed(() => props.radius - props.stroke * 2)
</script>
